module.exports = __webpack_public_path__ + "static/media/heat.9d450063.JPG";